import * as systemOrderFacadeImpl from "./systemOrderFacadeImpl";
import * as systemProductFacadeImpl from "./systemProductFacadeImpl";
import * as test from "./test";
import * as walmartItems from "./walmartItems";
import * as walmartItemsReport from "./walmartItemsReport";
import * as walmartNotifications from "./walmartNotifications";
import * as walmartOrder from "./walmartOrder";
import * as walmartOrderReturns from "./walmartOrderReturns";

export const walmart = {
  systemOrderFacadeImpl,
  systemProductFacadeImpl,
  test,
  walmartItems,
  walmartItemsReport,
  walmartNotifications,
  walmartOrder,
  walmartOrderReturns,
};
